module.exports = __webpack_public_path__ + "static/media/Q2.7d4c4486.png";